export const removeWhiteSpaces = (item: string) => item.replace(/\s/g, '');
